// source: pbtypes/gen/accessories/accessory_enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.accessories.AccessoryEnum', null, global);
goog.exportSymbol('proto.accessories.AccessoryEnum.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accessories.AccessoryEnum = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accessories.AccessoryEnum, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accessories.AccessoryEnum.displayName = 'proto.accessories.AccessoryEnum';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accessories.AccessoryEnum.prototype.toObject = function(opt_includeInstance) {
  return proto.accessories.AccessoryEnum.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accessories.AccessoryEnum} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accessories.AccessoryEnum.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accessories.AccessoryEnum}
 */
proto.accessories.AccessoryEnum.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accessories.AccessoryEnum;
  return proto.accessories.AccessoryEnum.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accessories.AccessoryEnum} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accessories.AccessoryEnum}
 */
proto.accessories.AccessoryEnum.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accessories.AccessoryEnum.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accessories.AccessoryEnum.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accessories.AccessoryEnum} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accessories.AccessoryEnum.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.accessories.AccessoryEnum.Enum = {
  NONE: 0,
  UNIDENTIFIABLE: 2,
  R35_PROP_GUARDS: 1,
  R47_GIMBAL_CINE: 64,
  R47_GIMBAL_DEFENDER: 65,
  R47_GIMBAL_INSPECTOR: 66,
  R47_GIMBAL_AIRCOVER: 67,
  R47_RTK_PROTO1: 70,
  R47_PARACHUTE_PROTO1: 80,
  R47_PARACHUTE_EVT: 81,
  R47_PARACHUTE_BOOTLOADER: 82,
  R47_PARACHUTE: 83,
  R47_SPOTLIGHT_EVT: 90,
  R47_SPOTLIGHT_PVT: 91,
  R47_SPEAKERMIC_EVT: 100,
  R47_SPEAKERMIC_PVT: 101,
  R47_NIGHT_AUTONOMY_PROTO3: 110,
  R47_NIGHT_AUTONOMY_PROTO4: 111,
  R47_NIGHT_AUTONOMY_QUAL1: 112,
  R47_GNSS_ATTACHMENT_PROTO3: 120,
  R47_RADIO_ATTACHMENT: 130,
  R47_DROPPER_PROTO1: 150,
  R47_DROPPER_PROTO2: 151,
  R47_A22_CELLULAR_ATTACHMENT: 140,
  R47_GENERIC_ATTACHMENT: 1022,
  R47_RID_DRONEBEACON_DB120: 1023,
  TRIVIAL_ATTACHMENT: 1024,
  R47_TOGGLE_ATTACHMENT: 1026
};

goog.object.extend(exports, proto.accessories);
